/**
 * MainBanner 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const MainBannerProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'mode',
        label: '배너 모드',
        control: 'Select',
        options: [
          { value: 'slider', label: '슬라이더 (자동 전환)' },
          { value: 'list', label: '목록 (가로 스크롤)' }
        ],
        defaultValue: 'slider'
      }
    ]
  },
  {
    group: '배너 관리',
    properties: [
      {
        name: 'bannerManager',
        label: '배너 목록',
        control: 'BannerManager',
        defaultValue: []
      }
    ]
  },
  {
    group: '미디어 설정',
    properties: [
      {
        name: 'mediaType',
        label: '미디어 타입',
        control: 'RadioGroup',
        options: [
          { value: 'image', label: '이미지' },
          { value: 'video', label: '비디오' }
        ],
        defaultValue: 'image'
      },
      {
        name: 'icon',
        label: '이미지 URL',
        control: 'ImageUpload',
        defaultValue: '',
        showIf: { field: 'mediaType', value: 'image' }
      },
      {
        name: 'videoUrl',
        label: '비디오 URL',
        control: 'TextField',
        defaultValue: '',
        showIf: { field: 'mediaType', value: 'video' }
      },
      {
        name: 'autoplay',
        label: '자동 재생',
        control: 'Checkbox',
        defaultValue: true,
        showIf: { field: 'mediaType', value: 'video' }
      },
      {
        name: 'loop',
        label: '비디오 반복 재생',
        control: 'Checkbox',
        defaultValue: true,
        showIf: { field: 'mediaType', value: 'video' }
      },
      {
        name: 'muted',
        label: '소리 음소거',
        control: 'Checkbox',
        defaultValue: true,
        showIf: { field: 'mediaType', value: 'video' }
      }
    ]
  },
  {
    group: '콘텐츠 설정',
    properties: [
      {
        name: 'text',
        label: '배너 제목',
        control: 'TextField',
        defaultValue: '배너 제목'
      },
      {
        name: 'description',
        label: '배너 설명',
        control: 'TextArea',
        defaultValue: '배너 설명 텍스트를 입력하세요.'
      },
      {
        name: 'url',
        label: '링크 URL',
        control: 'TextField',
        defaultValue: '#'
      },
      {
        name: 'position',
        label: '콘텐츠 위치',
        control: 'PositionGrid',
        options: [
          { value: '1', label: '좌측 상단' },
          { value: '2', label: '중앙 상단' },
          { value: '3', label: '우측 상단' },
          { value: '4', label: '좌측 중앙' },
          { value: '5', label: '가운데 중앙' },
          { value: '6', label: '우측 중앙' },
          { value: '7', label: '좌측 하단' },
          { value: '8', label: '중앙 하단' },
          { value: '9', label: '우측 하단' }
        ],
        defaultValue: '5'
      },
      {
        name: 'showTitle',
        label: '제목 표시',
        control: 'Checkbox',
        defaultValue: true
      },
      {
        name: 'showButton',
        label: '버튼 표시',
        control: 'Checkbox',
        defaultValue: true
      },
      {
        name: 'hasBackground',
        label: '배경 활성화',
        control: 'Checkbox',
        defaultValue: false
      },
      {
        name: 'mobileFullWidth',
        label: '모바일에서 전체 너비 사용',
        control: 'Checkbox',
        defaultValue: false
      }
    ]
  },
  {
    group: '텍스트 스타일',
    properties: [
      {
        name: 'textColor',
        label: '텍스트 색상',
        control: 'ColorPicker',
        defaultValue: 'white'
      },
      {
        name: 'textShadow',
        label: '텍스트 그림자',
        control: 'TextField',
        defaultValue: '0 1px 2px rgba(0, 0, 0, 0.6)'
      }
    ]
  },
  {
    group: '버튼 설정',
    properties: [
      {
        name: 'buttonText',
        label: '버튼 텍스트',
        control: 'TextField',
        defaultValue: '자세히 보기'
      },
      {
        name: 'transparentButton',
        label: '투명 배경 버튼',
        control: 'Checkbox',
        defaultValue: false
      },
      {
        name: 'buttonBgColor',
        label: '버튼 배경색',
        control: 'ColorPicker',
        defaultValue: '#ff6b6b'
      },
      {
        name: 'buttonTextColor',
        label: '버튼 텍스트 색상',
        control: 'ColorPicker',
        defaultValue: 'white'
      },
      {
        name: 'buttonHoverColor',
        label: '버튼 호버 색상',
        control: 'ColorPicker',
        defaultValue: '#ff5252'
      },
      {
        name: 'buttonWidth',
        label: '버튼 너비 (PC)',
        control: 'TextField',
        defaultValue: 'auto'
      },
      {
        name: 'buttonHeight',
        label: '버튼 높이 (PC)',
        control: 'TextField',
        defaultValue: 'auto'
      },
      {
        name: 'mobileButtonWidth',
        label: '버튼 너비 (모바일)',
        control: 'TextField',
        defaultValue: 'auto'
      },
      {
        name: 'mobileButtonHeight',
        label: '버튼 높이 (모바일)',
        control: 'TextField',
        defaultValue: 'auto'
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.width',
        label: '너비',
        control: 'TextField',
        defaultValue: '100%'
      },
      {
        name: 'style.height',
        label: '높이',
        control: 'TextField',
        defaultValue: 'auto'
      },
      {
        name: 'style.padding',
        label: '패딩',
        control: 'Spacing',
        defaultValue: '0'
      },
      {
        name: 'style.margin',
        label: '마진',
        control: 'Spacing',
        defaultValue: '0'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '0'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'TextField',
        defaultValue: 'none'
      }
    ]
  }
];

export default MainBannerProperties; 